/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Cmp_Codecs_PrInputs */

const en_fc_cmp_codecs_pr = /** @type {(inputs: Fc_Cmp_Codecs_PrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Broad format support incl. camera RAW`)
};

/**
* | output |
* | --- |
* | "Broad format support incl. camera RAW" |
*
* @param {Fc_Cmp_Codecs_PrInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_cmp_codecs_pr = /** @type {((inputs?: Fc_Cmp_Codecs_PrInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Cmp_Codecs_PrInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_cmp_codecs_pr(inputs)
});
export { fc_cmp_codecs_pr as "fc.cmp.codecs.pr" }